export default class AccountWishlistRecommendationItem {
  constructor(component) {
    this.dom = {
      $component: component,
      $wishListButton: component.querySelector('.js-iWishAdd')
    }
    this.state = {
      productInWishlist: false,
      inWishlistClass: 'inWishlist'
    }
    this.wishListClickHandler = this.wishListClick.bind(this)
    this.itemRemovedHandler = this.itemRemoved.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    dom.$wishListButton.addEventListener('click', this.wishListClickHandler)
    document.addEventListener('removewishlistitem', this.itemRemovedHandler)
    this.checkWishlist()
  }

  checkWishlist() {
    const {dom, state} = this
    const {productId, currentVariantId} = dom.$wishListButton.dataset
    if (isInWishlist(productId, currentVariantId)) {
      state.productInWishlist = true
      dom.$wishListButton.classList.add(state.inWishlistClass)
    }
  }

  wishListClick(e) {
    const {dom, state} = this
    const {productId, productTitle, currentVariantId} = e.currentTarget.dataset

    if (state.productInWishlist) return
    iwish_addOnly(productId, currentVariantId, productTitle)
    dom.$wishListButton.classList.add(state.inWishlistClass)
    state.productInWishlist = true
  }

  itemRemoved({detail}) {
    const {dom, state} = this
    const {productId} = dom.$wishListButton.dataset

    if (productId == detail.productId) {
      dom.$wishListButton.classList.remove(state.inWishlistClass)
      state.productInWishlist = false
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.AccountWishlistRecommendationItem = this
  }
}
